import React from 'react';
import { Helmet } from 'react-helmet';
import Services from './Services';

const ServicesPage = () => (
  <>
    <Helmet>
      <title>Services | MilaajBrandset</title>
      <meta
        name="description"
        content="Explore the wide range of digital services offered by MilaajBrandset, including web development, SEO, and more to grow your business."
      />
      <meta
        name="keywords"
        content="MilaajBrandset, services, digital marketing, web development, SEO, business growth"
      />
      <meta property="og:title" content="Services | MilaajBrandset" />
      <meta
        property="og:description"
        content="Explore the wide range of digital services offered by MilaajBrandset, including web development, SEO, and more to grow your business."
      />
    </Helmet>
    <Services />
  </>
);

export default ServicesPage;